/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Advanced_ExportInputs */



/**
* | output |
* | --- |
* | "Advanced Closed Caption File Export" |
*
* @param {Signup_Compare_Advanced_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_advanced_export = /** @type {((inputs?: Signup_Compare_Advanced_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Advanced_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "es") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
	return /** @type {LocalizedString} */ ("Advanced Closed Caption File Export")
});